import { Capacitor } from '@capacitor/core';

import HardwareBackButton from 'src/components/fragments/HardwareBackButton';

// Must stay inside BrowserRouter and DrawerManager — HardwareBackButton reads both.
function NativeListeners() {
    if (!Capacitor.isNativePlatform()) {
        return null;
    }

    return <HardwareBackButton />;
}

export default NativeListeners;
